export const patchFormacionAmonestado = (participante) => {
  return {
    amonestado: participante.amonestado,
  };
};

export const patchPartidoArbitro = (arbitro) => {
  return {
    idArbitro: arbitro.id,
  };
};

export const patchPartidoEstadio = (estadio) => {
  return {
    idEstadio: estadio.id,
  };
};

export const patchPartidoTipoFormacionLocal = (tipoFormacion) => {
  return {
    codigoTipoFormacionLocal: tipoFormacion ? tipoFormacion.codigo : null,
  };
};

export const patchPartidoTipoFormacionVisitante = (tipoFormacion) => {
  return {
    codigoTipoFormacionVisitante: tipoFormacion ? tipoFormacion.codigo : null,
  };
};

export const patchPartidoFecha = (anio, mes, dia) => {
  return {
    anioPartido: anio,
    mesPartido: mes,
    diaPartido: dia,
  };
};

export const expulsionPartido = (item) => {
  return {
    idEquipo: item.equipo && item.equipo.id,
    idFormacion: item.idFormacion,
    idPersona: item.persona && item.persona.id,
    tiempo: item.tiempo,
    minutos: item.minutos,
    codTipoExpulsion: item.tipoExpulsion && item.tipoExpulsion.codigo,
    codTipoMotivo: item.motivo && item.motivo.codigo,
    detalle: item.detalle,
  };
};

export const formacionPartido = (formacion) => {
  // Transforma el formato interno al formato que espera el backend en PUT/POST
  // Backend espera: apellidoPersonaSinId y nombrePersonaSinId (campos separados)
  // Internamente usamos: personaSinId: { apellido, nombre } (objeto)
  return formacion.map((x) => {
    return {
      idPartidoFormacion: x.idPartidoFormacion,
      idPartido: x.idPartido,
      orden: x.titularidad === 'E' ? null : x.orden, // Director técnico no tiene orden
      idEquipo: x.equipo && x.equipo.id,
      idPersona: x.persona && x.persona.id,
      apellidoPersonaSinId: x.personaSinId && x.personaSinId.apellido,
      nombrePersonaSinId: x.personaSinId && x.personaSinId.nombre,
      camiseta: x.camiseta,
      titularidad: x.titularidad,
      amonestado: x.amonestado,
      expulsado: x.expulsado,
    };
  });
};

export const insertGolPartido = (item) => {
  return {
    idEquipo: item.equipo && item.equipo.id,
    idFormacionJugador: item.idFormacionJugador,
    idJugador: item.jugador && item.jugador.id,
    tiempo: item.tiempo,
    minutos: item.minutos,
    codTipoConversion: item.tipoConversion && item.tipoConversion.codigo,
    observaciones: item.observaciones ? item.observaciones : '',
  };
};

export const updateGolPartido = (item) => {
  return {
    idEquipo: item.equipo && item.equipo.id,
    idFormacionJugador: item.formacionJugador && item.formacionJugador.idPartidoFormacion,
    idJugador: item.jugador && item.jugador.id,
    tiempo: item.tiempo,
    minutos: item.minutos,
    codTipoConversion: item.tipoConversion && item.tipoConversion.codigo,
    observaciones: item.observaciones ? item.observaciones : '',
  };
};

export const resultadoPartido = (item, idPartido) => ({
  idPartido,
  codTipoResultado: item.tipoResultado && item.tipoResultado.codigo,
  minutos: item.minutos,
  golesLocal: item.golesLocal,
  codResultadoLocal: item.codResultadoLocal || '',
  golesVisitante: item.golesVisitante,
  codResultadoVisitante: item.codResultadoVisitante || '',
  equipoAfectado: item.equipoAfectado || null,
  codResolucion: item.codResolucion || null,
  observaciones: item.observaciones || '',
});

export const sustitucionPartido = (item) => {
  return {
    idEquipo: item.equipo && item.equipo.id,
    tiempo: item.tiempo,
    minutos: item.minutos,
    idFormacionSale: item.idFormacionSale,
    idPersonaSale: item.jugadorSale && item.jugadorSale.id,
    idFormacionEntra: item.idFormacionEntra,
    idPersonaEntra: item.jugadorEntra && item.jugadorEntra.id,
    sinIngreso: item.sinIngreso,
    codTipoMotivo: item.motivo && item.motivo.codigo,
    detalle: item.detalle,
  };
};
